import { RouteComponent } from "react-router";
import { RouteFragment } from "../Imports";

export class NestedRouteFragment extends RouteFragment {
    constructor(
        route: string,
        component: RouteComponent,
        parent: RouteFragment,
        indexComponent?: RouteComponent | string
    ) {
        super(component, indexComponent);

        this.route = route;
        this.parent = parent;
        parent.registerChild(this);
    }

    protected formatUrl(): string {
        return this.getRoute();
    }
}
